var App = (function () {
  'use strict';

  App.icons = function() {
    var deleteIconSelector = '.js-delete-item';

    initDeleteForm(deleteIconSelector);

    function initDeleteForm(deleteIconSelector) {
      $(document).on('click', deleteIconSelector, function(){
        var icon = $(this);
        var deletedId = icon.attr('data-delete-id');
        var formMethod = icon.attr('data-method');
        var formSelector = icon.attr('data-target');

        var $form = $(formSelector);

        var fieldId = $form.find("input[name='id']");
        var fieldMethod = $form.find("input[name='method']");

        fieldId.val(deletedId);
        fieldMethod.val(formMethod);
      });
    }

  };

  return App;
})(App || {});
